import "./style.scss"

import 'jquery-form-validator';
import 'master';
import datepickerFactory from 'jquery-datepicker';

datepickerFactory($);

$(function() {

  $('#event-datepicker').datepicker();

  $.validate({
    form: '#form-catering-event-enquiry',
    validateOnBlur : false,
    errorMessagePosition : 'inline',
    scrollToTopOnError : false,
    inlineErrorMessageCallback: function($input, errorMessage, config) {
      if ($input.hasClass('error')) {
        $('.comp-error-list .inner').append('<p data-error-id='+$input.attr('id')+'>'+errorMessage+'</p>');
      }else{
        $('.comp-error-list p[data-error-id='+$input.attr('id')+']').remove();
      }
    },
    onError : function($form) {
      $('.comp-error-list').show();
      toNameAnchor('.comp-error-list');
    },
    onSuccess : function($form) {
      //generateEmail();
      autoEmailfunction();
      // setTimeout(function () {
      //   document.location.href = '/thank-you';
      // }, 500);
    },
    onValidate : function($form) {
      if ($('.comp-error-list p').length<=0) {
        $('.comp-error-list').hide();
      }
    }
  });

  //FB form
  $.validate({
    form: '#form-restaurants-event-booking',
    validateOnBlur : false,
    errorMessagePosition : 'inline',
    scrollToTopOnError : false,
    inlineErrorMessageCallback: function($input, errorMessage, config) {
      if ($input.hasClass('error')) {
        $('.comp-error-list .inner').append('<p data-error-id='+$input.attr('id')+'>'+errorMessage+'</p>');
      }else{
        $('.comp-error-list p[data-error-id='+$input.attr('id')+']').remove();
      }
    },
    onError : function($form) {
      $('.comp-error-list').show();
      toNameAnchor('.comp-error-list');
    },
    onSuccess : function($form) {
      // generateEmail();
      autoEmailfunctionFB();
      // setTimeout(function () {
      //   document.location.href = '/thank-you';
      // }, 500);
    },
    onValidate : function($form) {
      if ($('.comp-error-list p').length<=0) {
        $('.comp-error-list').hide();
      }
    }
  });

});


function toNameAnchor(target){
  if($(target).length>0){
    $('html, body').delay(200).animate({
            scrollTop: $(target).offset().top-$('header').outerHeight()
    }, 500);
  };
}

function generateEmail() {
  var emailTo = 'catering@hkfc.com';
  var emailSubject = 'Catering Event Enquiry';
  var emailBody = "\%0AName: " + $("#edit-submitted-your-name").val() + "\%0AHKFC membership: " + $("#edit-submitted-membership-no").val() 
  + "\%0APhone: " + $("#edit-submitted-phone-no").val() + "\%0AMobile: " + $("#edit-submitted-mobile").val() + "\%0AFax: " + $("#edit-submitted-fax").val() 
  + "\%0AEmail: " + $("#edit-submitted-e-mail").val() + "\%0A\%0A\%0A- Event Information\%0A\%0ADate: " + $("#event-datepicker").val() 
  + "\%0AStart time: " + $("#edit-submitted-start-time option:selected").val() + "\%0AEnd time: " + $("#edit-submitted-end-time option:selected").val() 
  + "\%0ANature of Function: " + $("#edit-submitted-nature-of-function option:selected").text() 
  + "\%0AVenue Preferred : " + $("#edit-submitted-venue-preferred option:selected").text() 
  + "\%0ANo. of expected people: " + $("#edit-submitted-no-of-expected-people").text() 
  + "\%0AType of Menu : " + $("#edit-submitted-type-of-menu option:selected").val() 
  + "\%0ANo. of expected people:\%0A" + $("#edit-submitted-no-of-expected-people").val() + "\%0AEnquiry:\%0A" + $("#edit-submitted-enquiry").val() + "\%0A\%0A\%0A";
  location.href = "mailto:" + emailTo + "?" +
    (emailSubject ? "&subject=" + emailSubject : "") +
    (emailBody ? "&body=" + emailBody : "");
}

var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://23.99.125.215';
// var _rootEshopAPIurl = (process.env.NODE_ENV == 'production')?  '':'http://23.75.104.238';
function autoEmailfunction() {
  
  var formId = $("body").attr("data-form");
  var _apiUrlUserInfo = _rootEshopAPIurl + '/Umbraco/api/form/cateringEventEnquiry';

  var _formDataCreate = [
    {
      "formId": formId,
      "name": $("#edit-submitted-your-name").val(),
      "memberNo": $("#edit-submitted-membership-no").val(),
      "phone": $("#edit-submitted-phone-no").val(),
      "mobile": $("#edit-submitted-mobile").val(),
      "fax": $("#edit-submitted-fax").val(),
      "email": $("#edit-submitted-e-mail").val(),
      "date": $("#event-datepicker").val(),
      "startTime": $("#edit-submitted-start-time option:selected").val(),
      "endTime": $("#edit-submitted-end-time option:selected").val(),
      "natureOfFunction": $("#edit-submitted-nature-of-function option:selected").text(),
      "venuePreferred": $("#edit-submitted-venue-preferred option:selected").text(),
      "typeOfMenu": $("#edit-submitted-type-of-menu option:selected").val() ,
      "noOfExpectedPpl": $("#edit-submitted-no-of-expected-people").val(),
      "enquiry": $("#edit-submitted-enquiry").val()
    
    }
  ];

  // console.log("_formDataCreate:", _formDataCreate[0])

  $.ajax({
		type: 'POST',
		url: _apiUrlUserInfo,		
    data: _formDataCreate[0],
    dataType: "json",
		contentType: "application/x-www-form-urlencoded",
		success: function success(response) {
			//Load API content
      
			if (response.Code == "400") {
        
				document.location.href = '/';
			} 

			if (response.Code == "200") {
        
        document.location.href = '/thank-you';
				
			}
		}
	});	

}

function autoEmailfunctionFB() {
  // console.log("here")
  var formId = $("body").attr("data-form");
  var _apiUrlUserInfo = _rootEshopAPIurl + '/Umbraco/api/form/fbOutletsEnquiry';

  var emailTo = $("#edit-submitted-nature-of-reservation option:selected").val();  
  var emailToDept = $("#edit-submitted-nature-of-reservation option:selected").text();  

  var _formDataCreate = [
    {
      "formId": formId,
      "name": $("#edit-submitted-your-name").val(),
      "memberNo": $("#edit-submitted-membership-no").val(),
      "phone": $("#edit-submitted-phone-no").val(),
      "mobile": $("#edit-submitted-mobile").val(),
      "fax": $("#edit-submitted-fax").val(),
      "email": $("#edit-submitted-e-mail").val(),
      "date": $("#event-datepicker").val(),
      "startTime": $("#edit-submitted-start-time option:selected").val(),
      "endTime": "10:30",
      "natureOfReservation": emailToDept,
      "noOfAttendance": $("#edit-submitted-no-of-attendance").val(),
      "remarks": $("#edit-submitted-club-event-remarks").val(),      
      "mailTo": emailTo
    
    }
  ];
  // alert("emailTo:" + emailTo)
  // console.log("_formDataCreate:", _formDataCreate[0])

  $.ajax({
		type: 'POST',
		url: _apiUrlUserInfo,		
    data: _formDataCreate[0],
    dataType: "json",
		contentType: "application/x-www-form-urlencoded",
		success: function success(response) {
			//Load API content
      
			if (response.Code == "400") {
        console.log(105)
				document.location.href = '/';
			} 

			if (response.Code == "200") {
        console.log(110)
        document.location.href = '/thank-you';
				
			}
		}
	});	

}
